<template>
  <div class="lp-modal-wrapper">
    <div class="columns is-multiline">
      <div class="column is-full">
        <lp-radio :val.sync="option.type"
                  value_name="value"
                  label_name="label"
                  :data="type_arr"></lp-radio>
      </div>

      <div class="column is-full" v-if="option.type===1">
        <admin-form-item label="개월 단위">
          <input class="input"
                 style="width:100px"
                 v-model="option.date_unit"
                 @input="e=>setUnit(e, 2)"
                 type="number">
        </admin-form-item>
      </div>

      <div class="column is-full">
        <admin-form-item label="이름">
          <input class="input"
                 v-model="option.name"
                 @input="e=> option.name = e.target.value"
                 type="text">
        </admin-form-item>
      </div>

      <div class="column is-full">
        <admin-form-item label="가격">
          <input class="input"
                 v-model="option.price"
                 @input="e=>setPrice(e, 10)"
                 type="number">
        </admin-form-item>
      </div>

      <div class="column is-full">
        <admin-form-item label="할인율">
          <div class="flex align-center">
            <input class="input"
                   style="width:100px"
                   v-model="option.discount"
                   @input="e=>setDiscount(e, 10)"
                   type="number">
            <lp-check-bool
              label="첫달만 할인"
              :checkedVal.sync="option.is_first"
              style="margin-left:12px"
              v-if="option.type===1"></lp-check-bool>
          </div>
        </admin-form-item>
      </div>
      <div class="column is-full" v-if="option.is_first">
        <admin-form-item label="첫달만 할인 시 만료일수 지정">
          <input class="input"
                 style="width:100px"
                 v-model="option.maximum"
                 @input="e=>setMaximum(e, 3)"
                 type="number">
        </admin-form-item>
      </div>
      <div class="column is-full" v-if="option.is_first">
        <admin-form-item label="첫달만 할인 시 할인율">
          <input class="input"
                 style="width:100px"
                 v-model="option.first_discount"
                 @input="e=>setfirstDiscount(e, 3)"
                 type="number">
        </admin-form-item>
      </div>
      <div class="btn-group-justify-end">
        <button @click="saveData" class="button is-primary">추가하기</button>
      </div>
    </div>
  </div>
</template>

<script>
  import LpRadio from "../common/LpRadio";
  import LpCheckBool from "../common/LpCheckBool";

  export default {
    props: {
      op: {
        type: Object
      },
      modify: {
        type: Boolean
      }
    },
    components: {
      LpCheckBool,
      LpRadio},
    data() {
      return {
        option: {
          id: 0,
          type: 0,
          name: '',
          date_unit: 1,
          price: 0,
          discount: 0,
          is_first: false,
          maximum:0,
          first_discount:0
        },
        type_arr: [
          { label: '1회 결제', value: 0 },
          { label: '정기 결제', value: 1 }
        ]
      }
    },
    watch: {
      'option.type'(n) {
        // 1회 결제일 경우
        if(n===0) {
          this.option.is_first = false;
          this.option.date_unit = 1;
          this.option.maximum = 0;
          this.option.first_discount = 0;
        }
      }
    },
    created(){
      if(this.op) {
        this.option = this.op
      }
    },
    methods: {
      saveData(){
        this.$emit('setOption', this.option);
        this.option = {
          id: 0,
          type: 0,
          date_unit: 1,
          price: 0,
          discount: 0,
          is_first: false,
          maximum:0,
          first_discount:0
        }
      },
      setPrice(e, max_length){
        if( e.target.value.length > max_length ){
          this.option.price = e.target.value.substr(0,max_length);
        }
        else {
          this.option.price = e.target.value;
        }
      },
      setDiscount(e, max_length){
        if( e.target.value.length > max_length ){
          this.option.discount = e.target.value.substr(0,max_length);
        }
        else if (e.target.value === '') {
          this.option.discount = 0;
        }
        else if (e.target.value < 0) {
          this.option.discount = 0;
        }
        else {
          this.option.discount = e.target.value;
        }
      },
      setUnit(e, max_length){
        if( e.target.value.length > max_length ){
          this.option.date_unit = e.target.value.substr(0,max_length);
        }
        else {
          this.option.date_unit = e.target.value;
        }
      },
      setMaximum(e, max_length){
        if( e.target.value.length > max_length ){
          this.option.maximum = e.target.value.substr(0,max_length);
        }
        else {
          this.option.maximum = e.target.value;
        }
      },
      setfirstDiscount(e, max_length){
        if( e.target.value.length > max_length ){
          this.option.first_discount = e.target.value.substr(0,max_length);
        }
        else {
          this.option.first_discount = e.target.value;
        }
      }
    }
  }
</script>

<style type="styl" lang="stylus" scoped>

</style>


